module.exports = __webpack_public_path__ + "static/img/xiaohuixiang.7d3d50b0.png";